import moment from 'moment';

export const IS_REPLENISH = {
  true: '开启',
  false: '关闭',
};

export const TABLECOLUMN = [
  {
    label: '货主名称',
    prop: 'customerName',
    minWidth: 180,
  },
  {
    label: '货主编码',
    prop: 'customerCode',
    width: 180,
  },
  {
    label: '企业名称',
    prop: 'corpName',
    width: 180,
  },
  {
    label: '租户名称',
    prop: 'ownerTenantName',
    width: 180,
  },
  {
    label: '租户编码',
    prop: 'ownerTenantId',
    width: 180,
  },
  {
    label: '状态',
    prop: 'status',
    width: 180,
    formatter: (row) => {
      if (['ENABLED'].includes(row.customerStatus)) {
        return '启用';
      }
      if (['DISABLED'].includes(row.customerStatus)) {
        return '禁用';
      }
      return '--';
    },
  },
  {
    label: '服务设置',
    prop: 'setting',
    width: 180,
  },
  {
    label: '创建时间',
    prop: 'createTime',
    width: 180,
    formatter: (row) => moment(row.createTime).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    label: '操作',
    prop: 'action',
    width: 180,
    fixed: 'right',
  },
];

export const CUSTOMERTYPE = {
  enterprise: '企业',
  personal: '个人',
};

export const AUTOACCEPTTYPE = {
  true: '自动接单',
  false: '手动接单',
};
